import { Stack } from "@mui/material";

import TableMsByRegion from "./table-ms-activities-by-region/TableMsByRegion";
import FilterMsActivityByRegion from "./filter-ms-activities-by-region/FilterMsActivityByRegion";

/**
 * Content component in tab Mobility Store Activities By Region
 * Contains filter and table
 */
const MsActivitiesByRegionTab = () => {
    return (
        <Stack rowGap={2}  px= {0} py={3}>
            <FilterMsActivityByRegion />
            <TableMsByRegion />
        </Stack>
    );
}

export default MsActivitiesByRegionTab;
